import { render } from "./ProfileBanner.vue?vue&type=template&id=01f21bb9&scoped=true"
import script from "./ProfileBanner.vue?vue&type=script&lang=js"
export * from "./ProfileBanner.vue?vue&type=script&lang=js"

import "./ProfileBanner.vue?vue&type=style&index=0&id=01f21bb9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f21bb9"]])

export default __exports__